import React, { FC } from "react";
import { useIsFetching } from "@tanstack/react-query";
import { ProgressBar, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  progressBar: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
  },
});

const Loading: FC = () => {
  const styles = useStyles();
  const loading = useIsFetching({ predicate: (query) => query.queryKey[0] !== "lastRefreshed" });

  return loading === 0 ? null : (
    <div data-testid="loading">
      <ProgressBar color="brand" className={styles.progressBar} />
    </div>
  );
};

export default Loading;
